import ReactDOM from 'react-dom/client';

import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import { QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { BrowserRouter } from 'react-router-dom';

import App from './App';
import reportWebVitals from './reportWebVitals';
import ThemeContextWrapper from './services/theme';

import './assets/styles/index.scss';

import './i18n';
// import { FpjsProvider } from "@fingerprintjs/fingerprintjs-pro-react";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

Sentry.init({
  dsn: 'https://e9c7b14eb319495cbc9a47a78316b752@o4504236001853440.ingest.sentry.io/4504401772675072',

  integrations: [
    new BrowserTracing(),
    new Sentry.Replay({
      blockAllMedia: false,
      maskAllText: false,
    }),
  ],
  replaysOnErrorSampleRate: 0.5,

  replaysSessionSampleRate: 0.1,

  tracesSampleRate: 0.5,
});

const root = ReactDOM.createRoot(document.querySelector('#root')!);

root.render(
  <QueryClientProvider client={queryClient}>
    <ReactQueryDevtools initialIsOpen={false} />
    <ThemeContextWrapper>
      <BrowserRouter>
        {/* <FpjsProvider
          loadOptions={{
            apiKey: "5KPFR0GjzdBFwSsPblik",
            region: "eu",
          }}
        > */}
        <App />
        {/* </FpjsProvider> */}
      </BrowserRouter>
    </ThemeContextWrapper>
  </QueryClientProvider>,
);

reportWebVitals();
